/**
 * Real tab lists for the two settings pages, per
 * assets/handoffs/design_handoff_app_shell, Rules — settings ("Chosen C —
 * two pages, split by scope"). Kept separate from
 * templates/AppShell/fixtures.js, which is demo-only data for /shell-demo.
 */

export const WORKSPACE_SETTINGS_TABS = [
  { key: "general", label: "General", to: "/organization-settings" },
  { key: "branding", label: "Branding", to: "/organization-settings/branding" },
  { key: "members", label: "Members", to: "/organization-settings/members", badge: "Beta" },
  { key: "billing", label: "Billing", to: "/organization-settings/billing" },
  { key: "domain", label: "Domain & links", to: "/organization-settings/domain", badge: "Beta" },
];

export const ACCOUNT_SETTINGS_TABS = [
  { key: "profile", label: "Profile", to: "/settings" },
  // { key: "affiliates", label: "Affiliates", to: "/settings/affiliates" },
];
